module.exports = __webpack_public_path__ + "static/media/blog-post.1.7a7ff05f.md";